import { render, staticRenderFns } from "./EditTags.vue?vue&type=template&id=5055a0af&scoped=true"
import script from "./EditTags.vue?vue&type=script&lang=js"
export * from "./EditTags.vue?vue&type=script&lang=js"
import style0 from "./EditTags.vue?vue&type=style&index=0&id=5055a0af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5055a0af",
  null
  
)

export default component.exports